// extracted by mini-css-extract-plugin
module.exports = {"button":"TermsOfPurchase_button__aNpvZ"};